import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Popper, PopperContent, PopperTrigger } from '@cp/src/components/Popper/Popper';
import { RootState } from '@cp/src/store';
import { DetailsPopperProps, CallingAgentAuditDetails } from '../../interface';
import DetailsPopperTrigger from './DetailsPopperTrigger';
import AnswerViewsSection from './AnswerViewsSection';
import CallSummarySection from './CallSummarySection';
import AuditDetailsSection from './AuditDetailsSection';
import { CALL_TYPE_LABELS } from '../constant';

const DetailsPopper = ({ isTDME = false, isDrawerOpen = true }: DetailsPopperProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const auditDetails = useSelector(
    (state: RootState) => state.callAudit?.callingAgentAuditDetails
  ) as CallingAgentAuditDetails | null;

  const callType = CALL_TYPE_LABELS[auditDetails?.callType || ''] || auditDetails?.callType || '';
  const callLanguage = auditDetails?.callLanguage || '';
  const tag = auditDetails?.tag || '';
  const callSummary = auditDetails?.callSummary;

  const callDisplayData = useMemo(
    () => ({
      callType: `${callType}${callLanguage ? `, ${callLanguage}` : ''}`,
      status: tag
    }),
    [callType, callLanguage, tag]
  );

  const answerViews = callSummary?.answerViews || [];

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isTDME && !isDrawerOpen) {
      setIsOpen(false);
    }
  }, [isTDME, isDrawerOpen]);

  return (
    <Popper
      placement="left-start"
      hideStrategy={undefined}
      open={isOpen}
      onOpenChange={setIsOpen}
      disableCloseOnOutsideClick={true}
    >
      <PopperTrigger>
        <DetailsPopperTrigger callDisplayData={callDisplayData} />
      </PopperTrigger>
      <PopperContent
        noHeader={true}
        className="max-w-[90vw] w-[350px] rounded-xl !left-2 !top-[-10px] bg-[var(--bg-primary)] shadow-lg z-[var(--z-index-overlay)] !visible"
        showArrow={false}
      >
        <div>
          <AnswerViewsSection answerViews={answerViews} onClose={handleClose} />
          <CallSummarySection callSummary={callSummary} />
          <AuditDetailsSection callSummary={callSummary} isTDME={isTDME} />
        </div>
      </PopperContent>
    </Popper>
  );
};

export default DetailsPopper;
